import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async getAccessToken() {
    try {
      await checkLicenseExpiry();
      const { data: auth } = await req.get('bimplus/bimpluslogin', {
        params: {},
      });
      return auth;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async setAccessToken(params) {
    try {
      await checkLicenseExpiry();
      const { data: auth } = await req.get('/bimplus/callback', {
        params,
      });
      return auth;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getTeams(params) {
    try {
      await checkLicenseExpiry();
      const teams = await req.post('bimplus/getTeams', { access_token: params });
      return teams.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getProjects(params) {
    try {
      await checkLicenseExpiry();
      const projects = await req.post('bimplus/getProjects', params);
      return projects.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getModels(params) {
    try {
      await checkLicenseExpiry();
      const models = await req.post('bimplus/getModels', params);
      return models.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async setBimplusDetails(params) {
    try {
      await checkLicenseExpiry();
      const project = await req.post('bimplus/setBimplusDetails', params);
      return project.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getElementTypes(params) {
    try {
      await checkLicenseExpiry();
      const elementTypes = await req.post('bimplus/getElementTypes', params);
      return elementTypes.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getObjectProperties(params) {
    try {
      await checkLicenseExpiry();
      const objectProperties = await req.post('bimplus/getObjectProperties', params);
      return objectProperties.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async setManufactonProperties(params) {
    try {
      await checkLicenseExpiry();
      const mfactProperties = await req.post('bimplus/setMfactProperties', params);
      return mfactProperties.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async requestGuids(id, isProject) {
    try {
      await checkLicenseExpiry();
      const guidsList = await req.get(`bimplus/guidDetails/${id}/${isProject}`);
      return guidsList.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }, 
  async syncGuids(params) {
    try {
      await checkLicenseExpiry();
      const guidsList = await req.post('bimplus/syncGuids', params);
      return guidsList.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async getElementDetails(params) {
    try {
      await checkLicenseExpiry();
      const objectProperties = await req.post('bimplus/getElementDetails', params);
      return objectProperties.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }, 
  async addAssemblyParts(params) {
    try {
      await checkLicenseExpiry();
      const data = await req.post('bimplus/addAssemblyParts', params);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },
  async addBimplusElements(params) {
    try {
      await checkLicenseExpiry();
      const data = await req.post('bimplus/addBimplusElements', params);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },
  async createBOM(params) {
    try {
      await checkLicenseExpiry();
      const data = await req.post('bimplus/createBOM', params);
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  }
};
